import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { TrackingService as SharedTrackingService } from '@avanta/shared/services/tracking';
import { type CreateTracking } from '@avanta/shared/types/tracking';
import { type AxiosRequestConfig, type AxiosResponse } from 'axios';

const API_URL = `${BASE_URL}tracking`;

export type TrackingServiceTypes = {
  createTracking: (
    patientId: string | number,
    trackingBody: CreateTracking,
    config?: AxiosRequestConfig
  ) => Promise<AxiosResponse<void>>;
  createTrackingByEmail: (
    email: string,
    trackingBody: CreateTracking,
    config?: AxiosRequestConfig
  ) => Promise<AxiosResponse<void>>;
};

export const TrackingService: TrackingServiceTypes = {
  createTracking: async (patientId, trackingBody, config) =>
    service.post(`${API_URL}/${patientId}`, trackingBody, config),
  createTrackingByEmail: async (email, trackingBody, config) =>
    SharedTrackingService.createTrackingByEmail(email, trackingBody, config),
};
